import { Paragraph } from "@cgc/ui/typography";
import { clsx } from "@cgc/ui/utils/clsx";
import React, { PropsWithChildren } from "react";

const FilterLabel: React.FC<PropsWithChildren<{ active?: boolean }>> = ({
  children,
  active,
}) => (
  <Paragraph
    className={clsx(
      "hover:text-cgc-green decoration-4 underline-offset-8 hover:underline",
      active && "text-cgc-green decoration-cgc-green underline",
    )}
  >
    {children}
  </Paragraph>
);

export default FilterLabel;
